/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2025. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */
import BaseApiService from './base.api-service';

const ENDPOINTS = {
  PATH: '/nerve/v2/node',
  VOLUMES: 'docker-resources/volumes',
};

class VolumesApiService extends BaseApiService {
  getListOfVolumes(data) {
    return this.get(`${ENDPOINTS.PATH}/${data.serialNumber}/${ENDPOINTS.VOLUMES}`, { authRequired: true });
  }

  deleteVolume({ name, serialNumber }) {
    return this.delete(`${ENDPOINTS.PATH}/${serialNumber}/${ENDPOINTS.VOLUMES}/${name}`, {
      authRequired: true,
    });
  }

  importDataToVolume({ name, serialNumber, formData }) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.post(`${ENDPOINTS.PATH}/${serialNumber}/${ENDPOINTS.VOLUMES}/${name}/import`, formData, options, {
      authRequired: true,
    });
  }

  exportVolume({ name, serialNumber }) {
    const options = {
      authRequired: true,
    };
    return this.post(`${ENDPOINTS.PATH}/${serialNumber}/${ENDPOINTS.VOLUMES}/${name}/export`, {}, options);
  }

  cancelVolumeImport({ name, serialNumber }) {
    const options = {
      authRequired: true,
    };
    return this.post(`${ENDPOINTS.PATH}/${serialNumber}/${ENDPOINTS.VOLUMES}/${name}/import/cancel`, {}, options);
  }

  cancelVolumeExport({ name, serialNumber }) {
    const options = {
      authRequired: true,
    };
    return this.post(`${ENDPOINTS.PATH}/${serialNumber}/${ENDPOINTS.VOLUMES}/${name}/export/cancel`, {}, options);
  }
}

export default new VolumesApiService();
